export default function ListButton({ action, content, icon, color }) {
  return (
    <button
      onClick={action} 
      className={`flex w-full justify-center items-center gap-2 bg-${color}-700 bg-opacity-10 hover:bg-${color}-200 transition-all duration-100 text-${color}-700 px-4 py-2 rounded-lg`}
    >
      <span className={`text-${color}-700 text-xs`}>{content}</span>
      {icon}
    </button>
  )
}